import {
  DirectoryMarketingContentSection,
  DirectorySettings,
} from '@accredible-frontend-v2/models';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DashboardApiService } from './db-api.service';

@Injectable({
  providedIn: 'root',
})
export class DirectoriesApiService extends DashboardApiService {
  loadDirectorySettings(directoryId: number): Observable<DirectorySettings> {
    const url = `/v1/dashboard/spotlight_directories/${directoryId}`;

    return this._get(url).pipe(
      map((res) => this._handleResponse(res, 'spotlight_directory')),
      catchError((res) => this._handleError(res)),
    );
  }

  loadDirectoryMarketingContent(
    directoryId: number,
  ): Observable<DirectoryMarketingContentSection[]> {
    const url = `/v1/issuer/spotlight_directories/${directoryId}/spotlight_directory_content_sections`;

    return this._get(url).pipe(
      map((res) => this._handleResponse(res, 'spotlight_directory_content_sections')),
      catchError((res) => this._handleError(res)),
    );
  }
}
